// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SectionHeader_mainDiv__PrqxB {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.SectionHeader_title__Ic1bi {
  color: var(--black-color);
  width: max-content;
}

.SectionHeader_rightDiv__38V98 {
  display: flex;
  gap: 20px;
  align-items: flex-end;
}

@media (max-width: 576px) {
  .SectionHeader_mainDiv__PrqxB {
    flex-direction: column;
    gap: 20px;
    align-items: flex-start;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Components/molecules/SectionHeader/SectionHeader.module.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,qBAAqB;AACvB;;AAEA;EACE;IACE,sBAAsB;IACtB,SAAS;IACT,uBAAuB;EACzB;AACF","sourcesContent":[".mainDiv {\n  width: 100%;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.title {\n  color: var(--black-color);\n  width: max-content;\n}\n\n.rightDiv {\n  display: flex;\n  gap: 20px;\n  align-items: flex-end;\n}\n\n@media (max-width: 576px) {\n  .mainDiv {\n    flex-direction: column;\n    gap: 20px;\n    align-items: flex-start;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"mainDiv": `SectionHeader_mainDiv__PrqxB`,
	"title": `SectionHeader_title__Ic1bi`,
	"rightDiv": `SectionHeader_rightDiv__38V98`
};
export default ___CSS_LOADER_EXPORT___;
